import React from 'react';
import { Select } from 'antd';
import _ from 'i18n';

const { Option } = Select;

const months = [
  { value: '01', label: _('JANUARY') },
  { value: '02', label: _('FEBRUARY') },
  { value: '03', label: _('MARCH') },
  { value: '04', label: _('APRIL') },
  { value: '05', label: _('MAY') },
  { value: '06', label: _('JUNE') },
  { value: '07', label: _('JULY') },
  { value: '08', label: _('AUGUST') },
  { value: '09', label: _('SEPTEMBER') },
  { value: '10', label: _('OCTOBER') },
  { value: '11', label: _('NOVEMBER') },
  { value: '12', label: _('DECEMBER') }
];

const MonthFilter = ({ startMonth, endMonth, handleStartMonthChange, handleEndMonthChange }) => {
  return (
    <div className={"flex items-center"}>
      <div className={"mr-2"}>
        <span className={" compare-stats-filters-font mr-2"}>{_('START_MONTH')}</span>
        <Select
          style={{ width: 120 }}
          onChange={handleStartMonthChange}
          value={startMonth}
        >
          {months.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      </div>
      <div>
        <span className={"compare-stats-filters-font mr-2"}>{_('END_MONTH')}</span>
        <Select
          style={{ width: 120 }}
          onChange={handleEndMonthChange}
          value={endMonth}
        >
          {months.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default MonthFilter;



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/CompareStats/MonthFilter.js